module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1072.7c67881a.png";